// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var VoicemailAction;
(function (VoicemailAction) {
    VoicemailAction["VOICEMAIL_ACTION_UNSPECIFIED"] = "VOICEMAIL_ACTION_UNSPECIFIED";
    VoicemailAction["VOICEMAIL_ACTION_READ"] = "VOICEMAIL_ACTION_READ";
    VoicemailAction["VOICEMAIL_ACTION_UNREAD"] = "VOICEMAIL_ACTION_UNREAD";
    VoicemailAction["VOICEMAIL_ACTION_DELETE"] = "VOICEMAIL_ACTION_DELETE";
    VoicemailAction["VOICEMAIL_ACTION_UNDELETE"] = "VOICEMAIL_ACTION_UNDELETE";
})(VoicemailAction || (VoicemailAction = {}));
export var VoicemailAction_index;
(function (VoicemailAction_index) {
    VoicemailAction_index[VoicemailAction_index["VOICEMAIL_ACTION_UNSPECIFIED"] = 0] = "VOICEMAIL_ACTION_UNSPECIFIED";
    VoicemailAction_index[VoicemailAction_index["VOICEMAIL_ACTION_READ"] = 1] = "VOICEMAIL_ACTION_READ";
    VoicemailAction_index[VoicemailAction_index["VOICEMAIL_ACTION_UNREAD"] = 2] = "VOICEMAIL_ACTION_UNREAD";
    VoicemailAction_index[VoicemailAction_index["VOICEMAIL_ACTION_DELETE"] = 3] = "VOICEMAIL_ACTION_DELETE";
    VoicemailAction_index[VoicemailAction_index["VOICEMAIL_ACTION_UNDELETE"] = 5] = "VOICEMAIL_ACTION_UNDELETE";
})(VoicemailAction_index || (VoicemailAction_index = {}));
/**
 * MessageStatus : Used to select message status
 */
export var MessageStatus;
(function (MessageStatus) {
    MessageStatus["MESSAGE_STATUS_ALL"] = "MESSAGE_STATUS_ALL";
    MessageStatus["MESSAGE_STATUS_READ"] = "MESSAGE_STATUS_READ";
    MessageStatus["MESSAGE_STATUS_UNREAD"] = "MESSAGE_STATUS_UNREAD";
})(MessageStatus || (MessageStatus = {}));
export var MessageStatus_index;
(function (MessageStatus_index) {
    MessageStatus_index[MessageStatus_index["MESSAGE_STATUS_ALL"] = 0] = "MESSAGE_STATUS_ALL";
    MessageStatus_index[MessageStatus_index["MESSAGE_STATUS_READ"] = 1] = "MESSAGE_STATUS_READ";
    MessageStatus_index[MessageStatus_index["MESSAGE_STATUS_UNREAD"] = 2] = "MESSAGE_STATUS_UNREAD";
})(MessageStatus_index || (MessageStatus_index = {}));
